var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"btn btn-default js-edit-blob",attrs:{"href":_vm.editPath},on:{"click":_vm.handleEditClick}},[_vm._v("\n  Edit\n")])}
var staticRenderFns = []

export { render, staticRenderFns }